import classNames from 'classnames';
import { TopTabType } from 'components/generics/buttons/TopTabs/types';
import { motion } from 'framer-motion';
import React, { HTMLAttributes, useState } from 'react';
import classes from './index.module.scss';
import { PROFILE_TABS } from 'pages/profile/utils';

interface Props extends HTMLAttributes<HTMLDivElement> {
  tabs: TopTabType[];
  onChangeTab: (tab: TopTabType) => void;
  tabClassName?: string;
  selectedTabClassName?: string;
  underlineClassName?: string;
  layoutId?: string;
  selectedTab: string;
  setSelectedTab: (tab: string) => void;
}

const TopTabs = ({
  tabs,
  onChangeTab,
  tabClassName,
  selectedTabClassName,
  underlineClassName,
  className,
  layoutId,
  selectedTab,
  setSelectedTab,
}: Props) => {
  const tabClickHandler = (tab: TopTabType) => {
    setSelectedTab(tab.value);
    onChangeTab(tab);
  };

  return (
    <div className={classNames(classes.container, className)}>
      <ul>
        {tabs.map((item) => (
          <li
            key={item.label}
            className={classNames(
              item.value === selectedTab ? selectedTabClassName : '',
              tabClassName
            )}
            onClick={() => tabClickHandler(item)}
          >
            {item.label}
            {item.value === selectedTab ? (
              <motion.div
                className={classNames(classes.underline, underlineClassName)}
                layoutId={layoutId || 'underline'}
              />
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TopTabs;
